// STARSEED-CAPMARKETS-072/073 — intake multi-select helpers.
//
// Q1 (`primary_reason`) and Q3 (`capital_location`) of the Capital
// Readiness intake are multi-select; legacy documents (and untouched
// single-select questions) still hold bare strings. These helpers keep
// the form state, validation, "Other" gating, and admin rendering
// tolerant of both shapes.

/** Immutable checkbox toggle — mirrors the Introducer Statements pattern. */
export const toggleSelection = (list, value) =>
  list.includes(value) ? list.filter((x) => x !== value) : [...list, value];

/** Required-field check: arrays need >= 1 selection; scalars need truthiness. */
export const isAnswered = (v) => (Array.isArray(v) ? v.length > 0 : Boolean(v));

/** "Other" free-text gate — works for both multi-select arrays and legacy scalars. */
export const includesOther = (v) =>
  Array.isArray(v) ? v.includes("Other") : v === "Other";

/** Admin renderer: arrays join comma-separated; scalars pass through. */
export const formatIntakeValue = (v) => (Array.isArray(v) ? v.join(", ") : v);

// STARSEED-CAPMARKETS-074 — primary + secondary financial goals (option 2).
// The primary stays a required single-select; the optional secondary list
// must never contain the current primary.

/** Options for the secondary-goals checkbox group: the primary is excluded. */
export const secondaryGoalOptions = (options, primary) =>
  options.filter((o) => o !== primary);

/**
 * Q6 primary-goal state transition: sets the new primary and prunes it from
 * the secondary selection so the two fields can never overlap client-side
 * (the API model strips overlaps defensively too).
 */
export const selectPrimaryGoal = (state, value) => ({
  ...state,
  financial_goal: value,
  secondary_financial_goals: (state.secondary_financial_goals || []).filter(
    (x) => x !== value
  ),
});
